var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("AppNotification", {
        attrs: {
          messageId: _vm.notificationId,
          message: _vm.notificationMessage,
          icon: _vm.notificationIcon,
          color: _vm.notificationColor,
          timeOut: _vm.notificationTimeOut,
        },
      }),
      _vm._v(" "),
      _c("AppHeader", {
        attrs: {
          pages: _vm.pages,
          currentPage: _vm.currentPage,
          navItems: _vm.navItems,
          isLoading: _vm.isLoading,
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.currentPage
            ? _c(_vm.currentPage.component, {
                tag: "component",
                attrs: {
                  breadCrumbs: _vm.breadCrumbs,
                  assetId: _vm.assetId,
                  activityId: _vm.activityId,
                  attachmentId: _vm.attachmentId,
                },
                on: {
                  onClickViewEquipmentFromAssetList: (val) =>
                    _vm.onClickViewEquipmentFromAssetList(val),
                  onClickViewEquipmentFromAttachmentDetail: (val) =>
                    _vm.onClickViewEquipmentFromAttachmentDetail(val),
                  onClickViewEquipmentFromActivityDetail: (val) =>
                    _vm.onClickViewEquipmentFromActivityDetail(val),
                  onClickViewActivityFromAssetDetail: (val) =>
                    _vm.onClickViewActivityFromAssetDetail(val),
                  onClickViewActivityFromAttachmentDetail: (val) =>
                    _vm.onClickViewActivityFromAttachmentDetail(val),
                  onClickViewAttachmentFromAssetDetail: (val) =>
                    _vm.onClickViewAttachmentFromAssetDetail(val),
                  onClickViewAttachmentFromActivityDetail: (val) =>
                    _vm.onClickViewAttachmentFromActivityDetail(val),
                  onClickBreadcrumb: (val) => _vm.onClickBreadcrumb(val),
                  notify: ({ message, icon, color, timeOut } = {}) => {
                    _vm.notificationMessage = message
                    _vm.notificationIcon = icon
                    _vm.notificationColor = color
                    _vm.notificationTimeOut = timeOut
                    _vm.notificationId++
                  },
                  isLoadingChange: (isLoadingUpdate) =>
                    (_vm.isLoading = isLoadingUpdate),
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }